import type { VoidFunctionComponent } from 'react';
import PaginationFooterPage from './PaginationFooterPage';
import PaginationFooterCount from './PaginationFooterCount';
import './Pagination.less';
import { STANDARD_COUNT_OPTIONS } from './consts';

type Props = {
  //  Current page of visible items
  page: number,
  //  Number of items visible per page
  count: number,
  //  Total number of items available
  totalItems: number,
  //  Function to update the current page
  setPage: (page: number) => void,
  //  Function to update the current count
  setCount: (count: number) => void,
  // Optional - Count options
  countOptions?: number[],
};

/**
 * This component represents a pagination footer with page and count options
 * flexed to the left and right (respectively).
 */
const PaginationFooter: VoidFunctionComponent<Props> = ({
  page,
  count,
  totalItems,
  setPage,
  setCount,
  countOptions = STANDARD_COUNT_OPTIONS,
}) => {
  return (
    <footer className="fossa-pagination-footer">
      <PaginationFooterPage page={page} count={count} totalItems={totalItems} setPage={setPage} />
      <PaginationFooterCount
        page={page}
        count={count}
        totalItems={totalItems}
        setCount={setCount}
        countOptions={countOptions}
      />
    </footer>
  );
};

export default PaginationFooter;
